import Network from "../../../../infrastructure/js/modules/network";

export function fetchManufacturers() {
  return Network.get('manufacturers');
};
